import React from "react";

import * as Styled from "./roi-request-duplicate.styled";

export const RoiRequestDuplicateSuccessBanner = ({
  onEdit,
  onDismiss,
}: {
  onEdit: () => void;
  onDismiss: () => void;
}) => (
  <Styled.SuccessBanner>
    <Styled.SuccessBannerContent>
      <Styled.SuccessBannerIcon>
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_1967_14828)">
            <path
              d="M14.6673 7.99967C14.6673 4.31777 11.6825 1.33301 8.00065 1.33301C4.31875 1.33301 1.33398 4.31777 1.33398 7.99967C1.33398 11.6815 4.31875 14.6663 8.00065 14.6663C11.6825 14.6663 14.6673 11.6815 14.6673 7.99967Z"
              fill="#06797F"
              stroke="#06797F"
              strokeWidth="1.5"
            />
            <path
              d="M5.33398 8L7.33398 10L10.6673 6"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_1967_14828">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </Styled.SuccessBannerIcon>
      <Styled.SuccessBannerText>
        The ROI request duplicated.
      </Styled.SuccessBannerText>
    </Styled.SuccessBannerContent>
    <Styled.SuccessBannerActions>
      <Styled.SuccessBannerAction type="button" onClick={onEdit}>
        Edit Request
      </Styled.SuccessBannerAction>
      <Styled.SuccessBannerDismiss
        type="button"
        aria-label="Dismiss success message"
        onClick={onDismiss}
      >
        <i className="pi pi-times" aria-hidden="true" />
      </Styled.SuccessBannerDismiss>
    </Styled.SuccessBannerActions>
  </Styled.SuccessBanner>
);
